import List from "./List";
import ManageEmployee from "./Manage";
import EmployeeAccounts from "./Accounts";
import { useEffect } from "react";
import {
  Redirect,
  Route,
  Switch,
  useParams,
  useRouteMatch,
} from "react-router-dom";

function Index() {
  const { params, url } = useRouteMatch();
  return <Switch>
    <Route path={`${url}/`} exact render={(props) => <List {...params} />} />
    <Route path={`${url}/accounts`} exact render={(props) => <EmployeeAccounts {...params} />} />
    <Route
      path={[`${url}/add`, `${url}/edit/:id`]}
      render={(props) => <ManageEmployee {...params} />}
    ></Route>
    <Route path="*" render={(props) => <Redirect to={`/404`} />}></Route>
  </Switch>;
}

export default Index;
